import { render, staticRenderFns } from "./Inputs.vue?vue&type=template&id=b6ec63e0&scoped=true"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"
import style0 from "./Inputs.vue?vue&type=style&index=0&id=b6ec63e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ec63e0",
  null
  
)

export default component.exports